import { QueryClient } from '@tanstack/react-query';
import type { PersistedClient, Persister } from '@tanstack/react-query-persist-client';
import { ApiError } from './api';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 7 * 24 * 3_600_000,
      // Réseau instable : on réessaie, sauf erreurs fonctionnelles 4xx.
      retry: (count, err) => (err instanceof ApiError && err.status >= 400 && err.status < 500 ? false : count < 2),
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 8000),
      networkMode: 'offlineFirst',
      refetchOnWindowFocus: false,
    },
    mutations: { networkMode: 'online', retry: false },
  },
});

/** Persistance du cache TanStack Query dans IndexedDB (Dexie chargé à la demande). */
export const idbPersister: Persister = {
  async persistClient(client: PersistedClient) {
    const { db } = await import('./db');
    await db.kv.put({ key: 'react-query', value: client });
  },
  async restoreClient() {
    const { db } = await import('./db');
    return (await db.kv.get('react-query'))?.value as PersistedClient | undefined;
  },
  async removeClient() {
    const { db } = await import('./db');
    await db.kv.delete('react-query');
  },
};

/** Requêtes personnelles exclues de la persistance (vidées à la déconnexion). */
export const PERSONAL_QUERY_ROOTS = ['me', 'zakat-history', 'payments-me', 'notifications', 'admin'];
